import React from 'react';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
// import EditCalendarIcon from '@mui/icons-material/EditCalendar';

function AutocompleteCqlFecha({ cqlFecha, handleDateChange }) {
    const datePart = cqlFecha.split(' ')[0]; // Extrae la parte de la fecha
    const timePart = cqlFecha.split(' ')[1]; // Extrae la parte de la hora
  
    const handleDateChangeInternal = (event) => {
    const newDatePart = event.target.value; // Nueva fecha seleccionada (yyyy-MM-dd)
    const newCqlFecha = `${newDatePart} ${timePart}`; // Combina la nueva fecha con la hora original
    handleDateChange(newCqlFecha); // Devuelve la fecha y hora completa al componente padre
    };

  return (
    <TextField
      label="Select Date"
      type="date"
      value={datePart}
      onChange={handleDateChangeInternal}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            {/* <EditCalendarIcon /> */}
          </InputAdornment>
        ),
      }}
      sx={{
        width: 185,
        height: 40,
        backgroundColor: '#f5f5f5', // Fondo claro y suave
        borderRadius: '8px', // Bordes redondeados
        boxShadow: '0px 2px 10px rgba(0, 0, 0, 0.1)', // Sombra para efecto de elevación
        userSelect: 'none', // Deshabilita la selección de texto
        '.MuiInputBase-input': {
            padding: '10px', // Más espacio interno para el texto
            color: '#333', // Color del texto principal
            userSelect: 'none', // Deshabilita la selección de texto
            pointerEvents: '-moz-initial', // Deshabilita eventos de clic en el texto
            userSelect: 'none', 
        },
        '.MuiOutlinedInput-notchedOutline': {
            borderColor: '#1976d2', // Color del borde al seleccionar
            userSelect: 'none', 
        },
        '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#115293', // Color del borde al pasar el ratón
            userSelect: 'none', 
        },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#1976d2', // Color del borde cuando está enfocado
            userSelect: 'none', 
        },
    }}
    />
  );
}

export default AutocompleteCqlFecha;
